import { APP_CONFIG } from '@sd/shared';
import { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { appVersionService } from '../services/appVersionService';

const THIRTY_MINUTES = 60000 * 30;

export const VersionChecker = () => {
  const [checkTimer, setCheckTimer] = useState<number>();
  const [showOutdatedMessage, setShowOutdatedMessage] = useState(false);

  const handleReload = () => window.location.reload();

  useEffect(() => {
    const timer = window.setInterval(() => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      appVersionService.getRemoteVersionInfo().then(remoteVersionInfo => {
        const isOutdated = APP_CONFIG.build.gitSha !== remoteVersionInfo.gitSha;
        if (isOutdated) {
          window.clearInterval(timer);
          setShowOutdatedMessage(true);
        }
      });
    }, THIRTY_MINUTES);
    setCheckTimer(timer);
    return () => window.clearInterval(checkTimer);
  }, []);

  return showOutdatedMessage ? (
    <Alert variant="warning">
      A new version of the application is available.{' '}
      <Alert.Link href={window.location.href} onClick={handleReload}>
        Refresh the page
      </Alert.Link>{' '}
      to update.
    </Alert>
  ) : null;
};
